module.exports = __webpack_public_path__ + "static/media/GalleryMain10.745c89f5.jpg";